import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

export default function QuestionnaireModeSelector({ displayFlag }) {
	
	
  const PAGE_URL_ANALYTICS = "/workflow/analytics";
  const PAGE_URL_RESPONSES = "/workflow/configuration/responses";
  const PAGE_URL_CONFIGURATION = "/workflow/configuration/configuration";

  const [hover, setHover] = useState(null);
  const history = useHistory();
  const location = useLocation();

  const thisContainer = {
    display: "flex",
    position: "fixed",
    top: "7px",
    left: "calc(50% - 250px)",
    zIndex: "20000",
    flexDirection: "column"
  };

  const primaryContainer = {
    display: "flex",
    width: "500px",
    height: "40px",
    background: "linear-gradient(180deg, #F4F7FA 0%, #DADFE6 100%)",
    borderRadius: "20px",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 3px 6px rgba(0,0,0,0.15)"
  };

  const baseLabel = {
    display: "flex",
    width: "33%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    color: "#333",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    borderRight: "1px solid rgba(255,255,255,0.3)",
    transition: "all 0.25s ease"
  };

  const glowStyle = {
    boxShadow: "0 0 12px rgba(77,168,255,0.75), inset 0 0 6px rgba(255,255,255,0.5)",
    background: "rgba(255,255,255,0.6)",
    borderRadius: "20px"
  };

  const splitLabel = {
    ...baseLabel,
    borderRight: "none"
  };

  const isActive = (path) => location.pathname.startsWith(path);

  const getStyle = (path) => ({
    ...baseLabel,
    ...(isActive(path) || hover === path ? glowStyle : {})
  });

  return (
    <div style={thisContainer}>
      <div style={primaryContainer}>

        {/* ANALYTICS */}
        <div
          style={getStyle(PAGE_URL_ANALYTICS)}
          onMouseEnter={() => setHover(PAGE_URL_ANALYTICS)}
          onMouseLeave={() => setHover(null)}
          onClick={() => history.push(PAGE_URL_ANALYTICS)}
        >
          Analytics
        </div>

        {/* RESPONSES */}
        <div
          style={getStyle(PAGE_URL_RESPONSES)}
          onMouseEnter={() => setHover(PAGE_URL_RESPONSES)}
          onMouseLeave={() => setHover(null)}
          onClick={() => history.push(PAGE_URL_RESPONSES)}
        >
          Responses
        </div>

        {/* CONFIG */}
        <div
          style={{
            ...splitLabel,
            ...(isActive(PAGE_URL_CONFIGURATION) || hover === PAGE_URL_CONFIGURATION ? glowStyle : {})
          }}
          onMouseEnter={() => setHover(PAGE_URL_CONFIGURATION)}
          onMouseLeave={() => setHover(null)}
          onClick={() => history.push(PAGE_URL_CONFIGURATION)}
        >
          Configuration
        </div>

      </div>
    </div>
  );
}
